import { render, staticRenderFns } from "./ProductRow.vue?vue&type=template&id=784a156d&scoped=true&slot=items&"
import script from "./ProductRow.vue?vue&type=script&lang=js&"
export * from "./ProductRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductRow.vue?vue&type=style&index=0&id=784a156d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a156d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VIcon})
